import { render, staticRenderFns } from "./FloatLikeBtn.vue?vue&type=template&id=5f981780&scoped=true"
import script from "./FloatLikeBtn.vue?vue&type=script&lang=ts"
export * from "./FloatLikeBtn.vue?vue&type=script&lang=ts"
import style0 from "./FloatLikeBtn.vue?vue&type=style&index=0&id=5f981780&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f981780",
  null
  
)

export default component.exports